import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageRoundedIcon from '@mui/icons-material/ContactPageRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';

// Tabs
import ProfileTab from "./Tabs/Profile";
import SecurityTab from "./Tabs/Security";

const tabs = [
  {label: "Account", icon: <ContactPageRoundedIcon fontSize="small" />},
  {label: "Security", icon: <SecurityRoundedIcon fontSize="small" />}
  ]

  const tabContent = [
    {panel: "profile", content: <ProfileTab />},
    {panel: "security", content: <SecurityTab />}
  ]

const ViewUser = () => {
  return (
    <ViewDetails title="User" identifier="display_name" tabs={tabs} tabContent={tabContent} isProfile={true} url="users">

    </ViewDetails>
  )
};

export default ViewUser;